import React from "react";
import Input from "../../../../ui/common/Input";
import ToggleSwitch from "../../../../ui/toggleSwitch/ToggleSwitch";
import "./TentaclesSettingsForms.scss";
import { getFieldValue } from "../fieldValue";
import JsonArrayTextArea from "./JsonArrayTextArea";

const TentaclesSettingsForm = ({ data, handleChanges }) => {
  return (
    <div className="inputs-container tentacles-settings-form-container">
      <JsonArrayTextArea
        label="Base Paths"
        value={getFieldValue(data.basePaths)}
        onChange={(value) => {
          handleChanges("basePaths", value);
        }}
        emptyValue=""
      />
      <JsonArrayTextArea
        label="Landing Page URLs"
        value={getFieldValue(data.landingPageUrls)}
        onChange={(value) => {
          handleChanges("landingPageUrls", value);
        }}
        emptyValue=""
      />
      <Input
        label="Cookiewall Accept Url"
        value={getFieldValue(data.cookiewallAcceptUrl)}
        onChange={(e) => {
          handleChanges("cookiewallAcceptUrl", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Domain Search Path"
        value={getFieldValue(data.domainSearchPath)}
        onChange={(e) => {
          handleChanges("domainSearchPath", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <JsonArrayTextArea
        label="Exclude Classes"
        value={getFieldValue(data.excludeClasses)}
        onChange={(value) => {
          handleChanges("excludeClasses", value);
        }}
      />
      {/* <Input label="Exclude Content" separateLines /> */}
      <Input
        label="Link Click Factor"
        type="number"
        value={getFieldValue(data.linkClickFactor)}
        onChange={(e) => {
          handleChanges("linkClickFactor", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.linkClickOnly)}
          onChange={(e) => {
            handleChanges("linkClickOnly", e);
          }}
        />
        <span className="switch-label">Link Click Only</span>
      </div>
      <Input
        value={getFieldValue(data.linkRegEx)}
        onChange={(e) => {
          handleChanges("linkRegEx", e.target.value);
        }}
        label="Link RegEx"
        fullWidth
        separateLines
      />
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.linkRegExOnParams)}
          onChange={(e) => {
            handleChanges("linkRegExOnParams", e);
          }}
        />
        <span className="switch-label">Link Reg Ex On Params</span>
      </div>
      <Input
        label="Loyalty Click30 Factor"
        value={getFieldValue(data.loyaltyClick30Factor)}
        onChange={(e) => {
          handleChanges("loyaltyClick30Factor", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Loyalty Click Factor"
        value={getFieldValue(data.loyaltyClickFactor)}
        onChange={(e) => {
          handleChanges("loyaltyClickFactor", e.target.value);
        }}
        fullWidth
        separateLines
      />
      {/* <Input label="Main Content" separateLines /> */}
      <Input
        label="Min Screenwidth"
        value={getFieldValue(data.minScreenwidth)}
        onChange={(e) => {
          handleChanges("minScreenwidth", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Period Minutes"
        type="number"
        value={getFieldValue(data.periodMinutes)}
        onChange={(e) => {
          handleChanges("periodMinutes", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Replacement Elements"
        value={getFieldValue(data.replacementElements)}
        onChange={(e) => {
          handleChanges("replacementElements", e.target.value);
        }}
        fullWidth
        separateLines
      />
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.useDivInReplacement)}
          onChange={(e) => {
            handleChanges("useDivInReplacement", e);
          }}
        />
        <span className="switch-label">Use Div In Replacement</span>
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.useIdsInXpaths)}
          onChange={(e) => {
            handleChanges("useIdsInXpaths", e);
          }}
        />
        <span className="switch-label">Use Ids In Xpaths</span>
      </div><div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.sendPageMapping)}
          onChange={(e) => {
            handleChanges("sendPageMapping", e);
          }}
        />

        <span className="switch-label">Send Page Mapping</span>
        
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.useTentacleViews)}
          onChange={(e) => {
            handleChanges("useTentacleViews", e);
          }}
        />
        <span className="switch-label">Use Tentacle Views (pageviews vs. tentacleviews)</span>
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.useIngestionApi)}
          onChange={(e) => {
            handleChanges("useIngestionApi", e);
          }}
        />
        <span className="switch-label">Use Ingestion Api</span>
      </div>

      <Input
        label="Video Path"
        checked={getFieldValue(data.videoPath)}
        onChange={(e) => {
          handleChanges("videoPath", e);
        }}
        fullWidth
        separateLines
      />
    </div>
  );
};

export default TentaclesSettingsForm;
